<template>
    <div class="form-item-container">
        <div class="form-item-header">
            <v-btn class="gorate-bg cursor-default" :icon="getFormItemIconIndex" height="30" variant="text" width="30"></v-btn>
            <div class="question">
                {{ formItem.question_lang1 }}
            </div>
        </div>
        <div class="form-item-body">
          <div class="option-container" v-for="(formItemOption, index) in formItem.form_item_options" :key="index">
              <div class="stats-data">
                <div v-if="formItemOption" class="option-value">{{ formItemOption.value }}</div>
                <div v-else class="option-value">N/A</div>
                <div v-if="!hasDistributionData(formItemIndex-1)" class="option-percentage">0%</div>
                <div v-else class="option-percentage">{{ getDistributionPercentage(formItemIndex-1, index, formItemOption?.value).toFixed(1) }}% ({{ getDistributionCount(formItemIndex-1, index, formItemOption?.value) }})</div>
              </div>
              <div class="progress-bar">
                  <v-progress-linear v-if="!hasDistributionData(formItemIndex-1)" rounded color="#d44d38" model-value="0" :height="8"></v-progress-linear>
                  <v-progress-linear v-else rounded color="#d44d38" :model-value="getDistributionPercentage(formItemIndex-1, index, formItemOption?.value)" :height="8"></v-progress-linear>
              </div>
          </div>
          <div class="submission-info-container">{{ $t('i18n.accesses') }}: {{ getTotalResponses(formItemIndex - 1) }} </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { FormItem, FormStats, MultiChoiceStatsDetail } from '@/utils/DataTypes'

export default defineComponent({
  name: 'NavigationStats',
  components: {
  },
  props: {
    stats: {
      type: Object as PropType<FormStats>,
      required: true,
      default: null
    },
    formItem: {
      type: Object as PropType<FormItem>,
      required: true,
      default: null
    },
    formItemIndex: {
      type: Number,
      required: true,
      default: -1
    },
    formName: {
      type: String,
      required: false,
      default: 'N/A'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    hasDistributionData (index: number): boolean {
      const formItemStats = this.stats?.data?.[index]

      if (!formItemStats) {
        console.error(`No form item option stats found. Form item option index: ${index}`)
        return false
      }

      const isMultiChoiceComponent = formItemStats.component_name === 'NavigationStats'

      if (formItemStats && isMultiChoiceComponent) {
        const multiChoiceDetail = formItemStats.detail as MultiChoiceStatsDetail
        return multiChoiceDetail.distribution?.length > 0
      }

      return false
    },
    getDistributionPercentage (formItemIndex: number, formOptionIndex: number, formItemOptionValue : string | undefined): number {
      if (formItemOptionValue === undefined) return 0
      const formItemStats = this.stats.data[formItemIndex]
      if ('distribution' in formItemStats.detail) {
        for (const optionStatsObj of formItemStats.detail.distribution) {
          if (optionStatsObj.option_value === formItemOptionValue) {
            return optionStatsObj?.percentage || 0
          }
        }
      }
      return 0
    },
    getDistributionCount (formItemIndex: number, formOptionIndex: number, formItemOptionValue : string | undefined): number {
      if (formItemOptionValue === undefined) return 0
      const formItemStats = this.stats.data[formItemIndex]
      if ('distribution' in formItemStats.detail) {
        for (const optionStatsObj of formItemStats.detail.distribution) {
          if (optionStatsObj.option_value === formItemOptionValue) {
            return optionStatsObj?.response_count || 0
          }
        }
      }
      return 0
    },
    getTotalResponses (index: number): number | string {
      return this.stats?.data?.[index]?.total_responses ?? 'N/A'
    }
  },
  computed: {
    getFormItemIconIndex () : string {
      return `mdi-numeric-${this.formItemIndex}`
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";

.form-item-container {
    padding: 1.0em 1.5em;
    border-radius: 0px 0px 15px 15px;

    display: grid;
    grid-template-rows: auto 1fr;

    .form-item-header {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: start;

        .question {
            padding: 0 0.8em;
        }
    }

    .form-item-body {
        display: flex;
        flex-direction: column;

        .option-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, 1fr);

            padding: 0.2em 0.4em 0em 0.4em;

            .stats-data {
                grid-row: 1;
                grid-column: 1 / 3;
                display: grid;
                grid-template-columns: repeat(2, auto);
                justify-content: space-between;
            }

            .progress-bar {
                grid-row: 2;
                grid-column: 1 / 3;
            }
        }

        .submission-info-container {
          flex: 1;
          display: grid;
          height: 100%;
          align-items: end;
          justify-content: start;
          padding: 1.2em 0em 0em 0em;
        }

    }
}
</style>
